import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell } from "recharts";
import { Target, CheckCircle2, Flame } from "lucide-react";

export default function DesempenhoPage() {
  const [perf, setPerf] = useState(null);

  useEffect(() => {
    api.get("/performance").then((r) => setPerf(r.data)).catch(() => {});
  }, []);

  const stats = [
    { label: "Questões respondidas", value: perf?.total ?? 0, icon: Target, color: "text-blue-400" },
    { label: "Acertos", value: perf?.correct ?? 0, icon: CheckCircle2, color: "text-emerald-400" },
    { label: "Aproveitamento", value: `${perf?.accuracy ?? 0}%`, icon: BarChart, color: "text-amber-400" },
    { label: "Dias seguidos", value: perf?.streak ?? 0, icon: Flame, color: "text-orange-400" },
  ];

  const chartData = (perf?.disciplinas || []).map((d) => ({ name: d.disciplina.split(" ").pop(), full: d.disciplina, accuracy: d.accuracy }));

  return (
    <div className="mx-auto max-w-4xl space-y-6 px-4 py-6 sm:px-6 sm:py-8">
      <div>
        <h1 className="text-2xl font-extrabold text-white">Desempenho</h1>
        <p className="text-sm text-slate-400">Acompanhe sua evolução por disciplina.</p>
      </div>

      <div className="grid grid-cols-2 gap-4 sm:grid-cols-4">
        {stats.map((s) => (
          <div key={s.label} className="rounded-2xl border border-slate-800 bg-slate-900 p-5">
            <s.icon className={`h-5 w-5 ${s.color}`} />
            <p className="mt-2 font-mono-stats text-2xl font-bold text-white">{s.value}</p>
            <p className="text-xs text-slate-500">{s.label}</p>
          </div>
        ))}
      </div>

      <div className="rounded-2xl border border-slate-800 bg-slate-900 p-5">
        <h2 className="mb-4 font-bold text-white">Aproveitamento por disciplina</h2>
        {chartData.length === 0 ? (
          <p className="py-10 text-center text-sm text-slate-500">Responda algumas questões para ver seus dados aqui.</p>
        ) : (
          <>
            <div className="h-64">
              <ResponsiveContainer width="100%" height="100%">
                <BarChart data={chartData} layout="vertical" margin={{ left: 10, right: 20 }}>
                  <XAxis type="number" domain={[0, 100]} hide />
                  <YAxis type="category" dataKey="name" width={90} tick={{ fill: "#94A3B8", fontSize: 12 }} axisLine={false} tickLine={false} />
                  <Bar dataKey="accuracy" radius={[0, 6, 6, 0]} barSize={22} label={{ position: "right", fill: "#E2E8F0", fontSize: 12, formatter: (v) => `${v}%` }}>
                    {chartData.map((d) => (
                      <Cell key={d.full} fill={d.accuracy >= 70 ? "#10B981" : d.accuracy >= 40 ? "#F59E0B" : "#EF4444"} />
                    ))}
                  </Bar>
                </BarChart>
              </ResponsiveContainer>
            </div>
            <div className="mt-4 space-y-2">
              {perf.disciplinas.map((d) => (
                <div key={d.disciplina} className="flex items-center justify-between text-sm">
                  <span className="text-slate-300">{d.disciplina}</span>
                  <span className="font-mono-stats text-slate-400">{d.correct}/{d.total} · {d.accuracy}%</span>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
